// extracted by mini-css-extract-plugin
export default {"snackbar":"SnackBar_snackbar__zAgHQ","right":"SnackBar_right__NbYRo","leftCollapse":"SnackBar_leftCollapse__RN0wy"};